import { render, staticRenderFns } from "./DAdminSsoMapping.vue?vue&type=template&id=a7466084&scoped=true&"
import script from "./DAdminSsoMapping.vue?vue&type=script&lang=js&"
export * from "./DAdminSsoMapping.vue?vue&type=script&lang=js&"
import style0 from "./DAdminSsoMapping.vue?vue&type=style&index=0&id=a7466084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7466084",
  null
  
)

export default component.exports